import { Grid } from "antd";
import { Navbar, Container } from "react-bootstrap";

import "./style.css";
// import * as action from "store/actions";

const LogoFull = "/assets/img/logo-full.png";
const LogoOnly = "/assets/img/logo-only.png";

const { useBreakpoint } = Grid;

const HeaderCheckoutContainer = () => {
  const screens = useBreakpoint();

  return (
    <>
      <Navbar
        bg="light"
        expand="lg"
        variant="light"
        expanded={false}
        className="bg-white py-2 navbar-container"
      >
        <Container className="container-navbar">
          <Navbar.Brand href="/">
            <img
              alt="logo"
              width={screens.xs ? "44" : "180"}
              src={screens.xs ? LogoOnly : LogoFull}
            />
          </Navbar.Brand>
        </Container>
      </Navbar>
    </>
  );
};

export default HeaderCheckoutContainer;
